module.exports = __webpack_public_path__ + "static/media/oilTanker.733d5a8e.svg";